export enum StepEnum {
  Introduction = 1,
  Otp,
  ContinueIntroduction,
  CardDetails,
  BankDetails,
  AccountPartners,
  Addresses,
  EmailAddress,
  ExistCreditCardDetails,
  CreditData,
  EmploymentStatus,
  MonthIncome,
  CreditLimitSplit,
  KnowYourCustomer,
  ChargeDate,
  CardActivity,
  MonthExpense,
  IdentificationQuestions,
  StandingOrder,
  Summary,
  Success,
  InstantIssuanceDesktop,
  RegisteryPopulation,
  RequestRecovery,
  DigitalForm,
  SuccessDigitalForm,
  DreamCardChildren,
  SuccessDreamCard,
}
